import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { ToastTypes, withToast } from "../contexts/toastr.context";
import leftIcon from "../_assets/images/left_icon.png";
import deleteIcon from "../_assets/images/survey_delete_icon.png";
import copyIcon from "../_assets/images/survey_copy_icon.png";
import Select from "react-select";
import DatePicker from "react-datepicker";
import { Button } from "../_components/button.component";
import { useForm, Controller } from "react-hook-form";
import { SurveysService } from "../_service/surveys.service";
import moment from "moment";
import Toggle from "react-toggle";
import "react-toggle/style.css";
import { useLocation } from "react-router-dom";
import calendarIcon from "../_assets/images/calendar.png";

import "react-datepicker/dist/react-datepicker.css";
import "react-datepicker/dist/react-datepicker-cssmodules.css";

export const CREATE_SURVEY_ROUTE = "/create-survey";

function CreateSurveyPageComponent({ user, history, addToast }) {
  const [surveyDate, setSurveyDate] = useState(null);
  const location = useLocation();

  let addQuestionTemplate = {
    title: "",
    questionType: { label: "Multiple Choice", value: "multipleChoice" },
    required: true,
    options: [
      { label: "Option 1", value: "" },
      { label: "Option 2", value: "" },
    ],
  };
  const [sessionFor, setSessionFor] = useState([
    { label: "Physicians", value: "physicians" },
    { label: "Nurses (non-clinical)", value: "nursesNonClinical" },
    { label: "Nurses (clinical)", value: "nursesClinical" },
    { label: "Allied Health", value: "alliedHealth" },
    { label: "Auxiliary Staff", value: "auxiliaryStaff" },
    { label: "Administrative Staff", value: "administrativeStaff" },
    { label: "Other", value: "other" },
  ]);

  const [questions, setQuestions] = useState([]);

  const [questionType, setQuestionType] = useState([
    { label: "Multiple Choice", value: "multipleChoice" },
    { label: "Scale", value: "scale" },
    { label: "Multi Select", value: "multiSelect" },
    { label: "Written Answer", value: "writtenAnswer" },
  ]);

  const [scaleStartLimit, setScaleStartLimit] = useState([
    { label: "0", value: 0 },
    { label: "1", value: 1 },
    { label: "2", value: 2 },
    { label: "3", value: 3 },
    { label: "4", value: 4 },
    { label: "5", value: 5 },
    { label: "6", value: 6 },
    { label: "7", value: 7 },
    { label: "8", value: 8 },
    { label: "9", value: 9 },
    { label: "10", value: 10 },
  ]);
  const [scaleEndtLimit, setScaleEndtLimit] = useState([
    { label: "0", value: 0 },
    { label: "1", value: 1 },
    { label: "2", value: 2 },
    { label: "3", value: 3 },
    { label: "4", value: 4 },
    { label: "5", value: 5 },
    { label: "6", value: 6 },
    { label: "7", value: 7 },
    { label: "8", value: 8 },
    { label: "9", value: 9 },
    { label: "10", value: 10 },
  ]);
  const [questionsErrorMsg, setQuestionsErrorMsg] = useState(undefined);
  const [isLoading, setIsLoading] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    setValue,
  } = useForm();

  useEffect(() => {
    if (location.state) {
      let selectedTemp = Object.keys(location.state.selectedTemplates).filter(
        (item) => location.state.selectedTemplates[item] === true
      );
      let templateQuestions = [];
      if (selectedTemp.length > 0) {
        selectedTemp.forEach((temp) => {
          let template = JSON.parse(
            JSON.stringify(require(`../_config/survey_templates/${temp}.json`))
          );
          templateQuestions = [...templateQuestions, ...template.questions];
        });
        setQuestions(templateQuestions);
      } else {
        setInitialQuestions();
      }
    } else {
      setInitialQuestions();
    }
  }, [location]);

  const setInitialQuestions = () => {
    setQuestions([
      {
        title: "",
        questionType: { label: "Multiple Choice", value: "multipleChoice" },
        required: true,
        options: [
          { label: "Option 1", value: "" },
          { label: "Option 2", value: "" },
        ],
      },
    ]);
  };

  /**
   * Add New Question
   * addQuestionTemplate is inserted into questions state
   */
  const addQuestionHandler = () => {
    setQuestionsErrorMsg(undefined);
    setQuestions([...questions, addQuestionTemplate]);
  };

  /**
   * Copy Question
   * copyQuestion function inserts copied question to its next index
   * sets new questions to questions state
   */
  const copyQuestion = (e, questionIndex, question) => {
    let tempQuestionsArr = new Array(...questions);
    let newCopy = JSON.parse(JSON.stringify(tempQuestionsArr[questionIndex]));
    tempQuestionsArr.splice(questionIndex + 1, 0, newCopy);
    setQuestions([...tempQuestionsArr]);
  };

  /**
   * Remove Single Question from Questions state
   * @param {*} index of particular question
   * removes specific index
   */
  const deleteQuestion = (index) => {
    let tempQuestionsArr = questions;
    tempQuestionsArr.splice(index, 1);
    if (questions.length < 1) {
      setQuestionsErrorMsg("Please add Survey Questions");
    }
    setQuestions([...tempQuestionsArr]);
  };

  /**
   * addAnotherOption function
   * @param {*} questionIndex, question
   * add new options in options array
   * updates questions state after updating particular question options
   */
  const addAnotherOption = (questionindex, question) => {
    let allQuestions = new Array(...questions);
    let questionNewCopy = JSON.parse(JSON.stringify(question));
    let addOptions = new Array(...allQuestions[questionindex].options);
    questionNewCopy.options.splice(addOptions.length + 1, 0, {
      label: `Option ${addOptions.length + 1}`,
      value: null,
    });
    allQuestions.splice(questionindex, 1, questionNewCopy);
    setQuestions([...allQuestions]);
  };

  /**
   * handleQuestionTitleChange function
   * @param {*} e, qindex
   * title value is invoked from e, qindex is used to save title to particular index question
   * updates questions state after updating particular question title
   */
  const handleQuestionTitleChange = (e, qindex) => {
    let allQuestions = questions;
    allQuestions[qindex].title = e.target.value;
    setQuestions([...allQuestions]);
  };

  /**
   * submitForm function
   * @param {*} data
   * questions state is assigned to tempAllQuestions
   * map is used to check validation errors
   * message is stored for every question. If question options are valid then message will be null otherwise string is assigned as per validation.
   * if isSubmittable is false then function gets returned
   * if isSubmittable is true then createSurvey function gets executed
   */
  const submitForm = (data) => {
    let tempAllQuestions = new Array(...questions);
    let isSubmittable = true;
    if (tempAllQuestions.length <= 0) {
      isSubmittable = false;
      setQuestionsErrorMsg("Please add Survey Questions");
    }
    tempAllQuestions.map((question, index) => {
      let message = "Invalid ";
      if (!question.title) {
        message = message + "Title";
        isSubmittable = false;
      }
      if (
        question.questionType.value !== "writtenAnswer" &&
        question.questionType.value !== "scale"
      ) {
        if (!question.options.every((item) => item.value)) {
          message =
            question.title.length <= 0
              ? message + " and Options"
              : message + "Options";
          isSubmittable = false;
        }
        if (question.title && question.options.every((item) => item.value)) {
          message = null;
          isSubmittable = isSubmittable ? true : isSubmittable;
        }
      }
      if (question.questionType.value === "scale") {
        if (
          question.title &&
          Object.keys(question.options[0]).every(
            (item) => question.options[0][item].value != undefined
          ) &&
          Object.keys(question.options[0]).every(
            (item) => question.options[0][item].label.trim().length > 0
          )
        ) {
          message = null;
          isSubmittable = isSubmittable ? true : isSubmittable;
        }
        if (
          !Object.keys(question.options[0]).every(
            (item) => question.options[0][item].value != undefined
          )
        ) {
          message =
            question.title.length <= 0
              ? message + " and Start or End value"
              : message + "Start or End value";
          isSubmittable = false;
        }
        if (
          !Object.keys(question.options[0]).every(
            (item) => question.options[0][item].label.trim().length >= 1
          )
        ) {
          if (
            !Object.keys(question.options[0]).every(
              (item) => question.options[0][item].value != undefined
            )
          ) {
            message =
              question.title.length <= 0
                ? message + " and Start or End label"
                : message + " and Start or End label";
          } else {
            message =
              question.title.length <= 0
                ? message + " and Start or End label"
                : message + " Start or End label";
          }
          isSubmittable = false;
        }
      }
      tempAllQuestions[index].errorMessage =
        message === "Invalid " ? undefined : message;
    });
    setQuestions([...tempAllQuestions]);
    if (!isSubmittable) {
      return;
    }
    data.dueDate = moment(data.dueDate).format("YYYY-MM-DD");
    createSurvey(data, questions);
  };

  /**
   * camelize function
   * @param {*} str
   * this function gets str and return camel case str by converting it
   */
  const camelize = (str) => {
    return str
      .replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
        return index === 0 ? word.toLowerCase() : word.toUpperCase();
      })
      .replace(/\s+/g, "");
  };

  /**
   * handleOptionValues function
   * @param {*} e, qindex, oindex
   * Its used for updating option label and its value
   * questions state is updated once question options label and value is updated
   */
  const handleOptionValues = (e, qindex, oindex) => {
    let allQuestions = questions;
    allQuestions[qindex].options[oindex].label = e.target.value;
    allQuestions[qindex].options[oindex].value = camelize(e.target.value);
    setQuestions([...allQuestions]);
  };

  /**
   * handleQuestionTypeChange function
   * @param {*} e, qindex
   *This function updates question options as per selected question type and updates questions state
   */
  const handleQuestionTypeChange = (e, qindex) => {
    let allQuestions = questions;
    allQuestions[qindex].questionType = e;
    allQuestions[qindex].errorMessage = null;
    allQuestions[qindex].required = true;
    if (
      allQuestions[qindex].questionType.value !== "writtenAnswer" &&
      allQuestions[qindex].questionType.value !== "scale"
    ) {
      allQuestions[qindex].options = [
        { label: "Option 1", value: "" },
        { label: "Option 2", value: "" },
      ];
    }
    if (allQuestions[qindex].questionType.value === "scale") {
      allQuestions[qindex].options = [
        {
          start: {
            label: "",
            value: undefined,
          },
          end: {
            label: "",
            value: undefined,
          },
        },
      ];
    }
    if (allQuestions[qindex].questionType.value === "writtenAnswer") {
      allQuestions[qindex].options = [
        { label: "Option 1", value: "" },
        { label: "Option 2", value: "" },
      ];
    }
    setQuestions([...allQuestions]);
  };

  /**
   * createSurvey function
   * @param {*} data, newAllQuestionArray
   * data - survey form (title, description, who is the survey for, due date)
   * newAllQuestionArray - questions array
   *This function invokes createSurvey function from  SurveysService to initiate API call
   */
  const createSurvey = (data, newAllQuestionArray) => {
    setIsLoading(true);
    newAllQuestionArray.forEach((newQuestion) => {
      delete newQuestion.errorMessage;
      if (newQuestion.questionType.value === "writtenAnswer") {
        delete newQuestion.options;
      }
    });
    SurveysService.createSurvey(user, {
      ...data,
      questions: newAllQuestionArray,
    })
      .then((resp) => {
        setIsLoading(false);
        history.push("/survey");
        addToast("Survey created successfully", "", ToastTypes.success);
      })
      .catch((error) => {
        setIsLoading(false);
        addToast("Unable to Create Survey", "", ToastTypes.danger);
        console.log(error);
      });
  };

  /**
   * changeRequiredHandler function
   * @param {*} e, qindex
   * this function updates required property
   * question array is updated
   */
  const changeRequiredHandler = (e, qindex) => {
    let allQuestions = questions;
    allQuestions[qindex].required = e.target.checked;
    setQuestions([...allQuestions]);
  };

  /**
   * handleScaleStartChange function
   * @param {*} e, qindex, question
   * updated scale option start value
   */
  const handleScaleStartChange = (e, qindex, question) => {
    let allQuestions = new Array(...questions);
    let questionNewCopy = JSON.parse(JSON.stringify(question));
    questionNewCopy.options[0].start.value = e;
    allQuestions.splice(qindex, 1, questionNewCopy);
    setQuestions([...allQuestions]);
  };

  /**
   * handleScaleEndChange function
   * @param {*} e, qindex, question
   * updated scale option end value
   */
  const handleScaleEndChange = (e, qindex, question) => {
    let allQuestions = new Array(...questions);
    let questionNewCopy = JSON.parse(JSON.stringify(question));
    questionNewCopy.options[0].end.value = e;
    allQuestions.splice(qindex, 1, questionNewCopy);
    setQuestions([...allQuestions]);
  };

  /**
   * handleStartLabelChange function
   * @param {*} e, qindex, question
   * updated scale option start label
   */
  const handleStartLabelChange = (e, qindex, question) => {
    let allQuestions = new Array(...questions);
    let questionNewCopy = JSON.parse(JSON.stringify(question));
    questionNewCopy.options[0].start.label = e;
    allQuestions.splice(qindex, 1, questionNewCopy);
    setQuestions([...allQuestions]);
  };

  /**
   * handleEndLabelChange function
   * @param {*} e, qindex, question
   * updated scale option end label
   */
  const handleEndLabelChange = (e, qindex, question) => {
    let allQuestions = new Array(...questions);
    let questionNewCopy = JSON.parse(JSON.stringify(question));
    questionNewCopy.options[0].end.label = e;
    allQuestions.splice(qindex, 1, questionNewCopy);
    setQuestions([...allQuestions]);
  };

  return (
    <div className="page-container ml-auto px-9 py-6 org-management-container create-survey-page-container">
      <form onSubmit={handleSubmit((data) => submitForm(data))}>
        <div className="flex items-center justify-between pb-4">
          <div className="flex back-btn-container items-center cursor-pointer">
            <img
              src={leftIcon}
              alt=""
              onClick={() => history.push("/survey")}
            />
            <span
              className="ml-3 text-xl home-text t-grey"
              onClick={() => history.push("/survey")}>
              Survey
            </span>
          </div>
          {/* <div>
            <Button
              label="Finish"
              type="submit"
              className="btn-primary rounded px-8 py-2 font-bold"
              isLoading={isLoading}
            />
          </div> */}
        </div>
        <div>
          {/* Title, Description container */}
          <div className="bg-white card px-11 py-9 relative rounded-lg w-96 w-full">
            <div className="flex items-stretch justify-between w-full">
              <div className="w-2/5">
                <input
                  name="title"
                  placeholder="Untitled Survey"
                  className="block w-3/4 survey-title-input"
                  {...register("title", {
                    required: "Title is required",
                  })}
                />
                <p className={`text-red-500 text-xs h-2.5`}>
                  {errors.title?.message}
                </p>
                <input
                  name="description"
                  placeholder="Write Survey Description"
                  className="block w-3/4 mt-2.5 survey-descr-input"
                  {...register("description", {
                    required: "Description is required",
                    maxLength: {
                      value: 150,
                      message:
                        "Description should not be more than 150 characters",
                    },
                  })}
                />
                <p className={`text-red-500 text-xs h-2.5`}>
                  {errors.description?.message}
                </p>
              </div>
              <div className="w-2/5">
                <Controller
                  name="whoThisSurveyIsFor"
                  {...register("whoThisSurveyIsFor", {
                    required: "Audience is required",
                  })}
                  render={({ field }) => (
                    <Select
                      {...field}
                      isMulti
                      options={sessionFor}
                      className="w-4/5 m-auto"
                      placeholder="Who is the survey for?"
                      styles={{
                        valueContainer: (base) => ({
                          ...base,
                          overflowX: "auto",
                          flexWrap: "unset",
                        }),
                        multiValue: (base) => ({
                          ...base,
                          flex: "0 0 auto",
                        }),
                      }}
                    />
                  )}
                  control={control}
                  defaultValue=""
                />
                <p className={`text-red-500 text-xs h-2.5 m-auto w-4/5`}>
                  {errors.whoThisSurveyIsFor?.message}
                </p>
              </div>
              <div className="w-1/5">
                <div className="flex items-center border rounded px-2">
                  <img src={calendarIcon} alt="calendar" className="w-3 mr-2" />
                  <label className="t-grey">Due:</label>
                  <Controller
                    name="dueDate"
                    {...register("dueDate", {
                      required: "Due date is required",
                    })}
                    render={({ field, ref }) => (
                      <DatePicker
                        {...field}
                        className="m-auto mt-0 w-full py-2 px-2 t-grey"
                        placeholderText={`${moment().format("MMMM, DD, yy")}`}
                        onChange={(date) => field.onChange(date)}
                        selected={field.value}
                        dateFormat="MMMM, dd, y"
                        minDate={new Date()}
                        ref={ref}
                      />
                    )}
                    control={control}
                  />
                </div>
                <p className={`text-red-500 text-xs h-2.5`}>
                  {errors.dueDate?.message}
                </p>
              </div>
            </div>
          </div>

          {/* Questions container */}
          {questions.map((question, qindex) => {
            return (
              <div
                className="bg-white card px-11 py-9 relative rounded-lg w-96 w-full questions-container mt-4"
                key={qindex}
                id={`question_${qindex}`}>
                <div className="flex items-center justify-between w-full ">
                  <div className="w-2/5">
                    <input
                      placeholder="Enter Text"
                      className="survey-question-title-input t-grey w-full pb-2"
                      type="text"
                      style={{
                        borderBottom: "1px solid #000000",
                      }}
                      value={questions[qindex].title}
                      onChange={(e) => {
                        handleQuestionTitleChange(e, qindex);
                      }}
                    />
                  </div>
                  <div className="w-2/5" id={`question_type_${qindex}`}>
                    <Select
                      options={questionType}
                      className="w-4/5 ml-auto"
                      styles={{
                        valueContainer: (base) => ({
                          ...base,
                          overflowX: "auto",
                          flexWrap: "unset",
                        }),
                        multiValue: (base) => ({
                          ...base,
                          flex: "1 0 auto",
                        }),
                      }}
                      value={question.questionType}
                      onChange={(e) => handleQuestionTypeChange(e, qindex)}
                    />
                  </div>
                </div>
                <div
                  className="flex items-center mb-2 mt-2 justify-between"
                  style={{ width: "22%" }}>
                  <span id="biscuit-label" className="mr-4 t-grey">
                    Required?
                  </span>
                  <Toggle
                    id="survey-required-toggle"
                    defaultValue={false}
                    checked={questions[qindex].required}
                    onChange={(e) => changeRequiredHandler(e, qindex)}
                  />
                </div>
                <div
                  className={`flex mt-4 ${
                    question.questionType.value === "writtenAnswer"
                      ? "mt-20 w-full"
                      : "mt-4"
                  }`}>
                  {question.questionType.value === "multiSelect" ||
                  question.questionType.value === "multipleChoice" ? (
                    <div className="w-2/3 options-container">
                      {question.options.map((option, oindex) => {
                        return (
                          <div className="flex items-center" key={oindex}>
                            <label
                              className={`option-${
                                question.questionType.value === "multipleChoice"
                                  ? "circle"
                                  : "square"
                              } mr-2`}></label>
                            <input
                              placeholder={`${option.label}`}
                              value={
                                option.value && option.label
                                  ? option.label
                                  : option.value
                              }
                              className="t-grey cursor-pointer"
                              type="text"
                              onChange={(e) =>
                                handleOptionValues(e, qindex, oindex)
                              }
                            />
                          </div>
                        );
                      })}
                      <div className="flex items-center">
                        <label
                          className={`option-${
                            question.questionType.value === "multipleChoice"
                              ? "circle"
                              : "square"
                          } mr-2`}></label>
                        <label
                          className="t-grey cursor-pointer add-option-label"
                          onClick={() => addAnotherOption(qindex, question)}>
                          Add Another Option
                        </label>
                      </div>
                    </div>
                  ) : (
                    <></>
                  )}
                  {question.questionType.value === "scale" ? (
                    <div className="w-2/3 options-container">
                      <div className="flex items-center mb-4 w-1/3">
                        <select
                          className="w-2/5 t-grey rounded px-2 py-1 border"
                          onChange={(e) => {
                            handleScaleStartChange(
                              e.target.value,
                              qindex,
                              question
                            );
                          }}
                          defaultValue={
                            question.options[0].start.value != undefined
                              ? question.options[0].start.value
                              : null
                          }>
                          <option></option>
                          {scaleStartLimit.map((scale, index) => {
                            return (
                              <option
                                value={scale.value}
                                disabled={
                                  question.options[0].end.value <= scale.value
                                }
                                key={index}>
                                {scale.label}
                              </option>
                            );
                          })}
                        </select>
                        <p className="mr-2 ml-2 t-grey w-1/5 text-center">to</p>
                        <select
                          className="w-2/5 t-grey rounded px-2 py-1 border"
                          onChange={(e) => {
                            handleScaleEndChange(
                              e.target.value,
                              qindex,
                              question
                            );
                          }}
                          defaultValue={
                            question.options[0].end.value != undefined
                              ? question.options[0].end.value
                              : null
                          }>
                          <option></option>
                          {scaleEndtLimit.map((scale, index) => {
                            return (
                              <option
                                value={scale.value}
                                disabled={
                                  scale.value <= question.options[0].start.value
                                }
                                key={index}>
                                {scale.label}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                      <div className="w-1/3">
                        <input
                          className="border block mb-3 rounded p-2 w-full t-grey"
                          placeholder={`${
                            question.options[0]?.start?.value != undefined
                              ? question.options[0]?.start?.value
                              : "Start"
                          } label`}
                          value={`${
                            question.options[0]?.start?.label
                              ? question.options[0]?.start?.label
                              : ""
                          }`}
                          onChange={(e) => {
                            handleStartLabelChange(
                              e.target.value,
                              qindex,
                              question
                            );
                          }}
                        />
                        <input
                          className="border block rounded  p-2 w-full t-grey"
                          placeholder={`${
                            question.options[0]?.end?.value != undefined
                              ? question.options[0]?.end?.value
                              : "End"
                          } label`}
                          value={`${
                            question.options[0]?.end?.label
                              ? question.options[0]?.end?.label
                              : ""
                          }`}
                          onChange={(e) => {
                            handleEndLabelChange(
                              e.target.value,
                              qindex,
                              question
                            );
                          }}
                        />
                      </div>
                    </div>
                  ) : (
                    <></>
                  )}
                  <div
                    className={`flex justify-end w-1/3 survey-create-action-btns-container ${
                      question.questionType.value === "writtenAnswer"
                        ? "w-full"
                        : "w-1/3"
                    }`}>
                    <div className="flex justify-end w-4/5 items-end">
                      <img
                        src={copyIcon}
                        alt="copy icon"
                        className="survey-create-action-btns cursor-pointer"
                        onClick={(e) => copyQuestion(e, qindex, question)}
                      />
                      <img
                        src={deleteIcon}
                        alt="delete icon"
                        className="survey-create-action-btns ml-4  cursor-pointer"
                        onClick={() => deleteQuestion(qindex)}
                      />
                    </div>
                  </div>
                </div>
                <div className="mt-1">
                  <p className={`text-red-500 text-xs h-2.5`}>
                    {question?.errorMessage}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
        {questionsErrorMsg ? (
          <>
            <p className={`text-red-500 text-xs h-2.5 mt-3`}>
              {questionsErrorMsg}
            </p>
          </>
        ) : (
          <></>
        )}
        <div className="mt-4 flex justify-between flex-row-reverse">
          <Button
            label="Finish"
            type="submit"
            className="btn-primary rounded px-8 py-2 font-bold"
            isLoading={isLoading}
          />
          <Button
            label="+ Question"
            className="btn-primary rounded px-4 py-2 add-question-btn"
            onClick={() => addQuestionHandler()}
          />
        </div>
      </form>
    </div>
  );
}

const CreateSurveyPage = withToast(
  connect((state) => ({
    user: state.auth,
  }))(CreateSurveyPageComponent)
);

export default CreateSurveyPage;
